export enum QuestionTypeEnum {
    CHECK_ONE= "CHECK_ONE",
    CHECK_MULTIPLE= "CHECK_MULTIPLE",
    FILL_BLANK= "FILL_BLANK",
    FILL_IN_THE_GAPS="FILL_IN_THE_GAPS",
    OPEN="OPEN"
}